import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Badge } from "@/components/ui/badge";
import { isDesktopApp } from "../lib/desktop";

export function MainProcessLog() {
  const [logs, setLogs] = useState([]);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!isDesktopApp() || !window.electron?.mainLog) {
      return;
    }

    let active = true;

    async function init() {
      try {
        const initial = await window.electron.mainLog.get();
        if (active) setLogs(initial);
        const cleanup = await window.electron.mainLog.subscribe((entry) => {
          setLogs((prev) => [...prev.slice(-199), entry]);
        });
        if (active) setConnected(true);

        window.__mainLogCleanup = cleanup;
      } catch (e) {
        console.warn('MainProcessLog: no se pudo conectar', e);
      }
    }

    init();

    return () => {
      active = false;
      if (window.__mainLogCleanup) {
        window.__mainLogCleanup().catch(() => {});
        delete window.__mainLogCleanup;
      }
    };
  }, []);

  if (!isDesktopApp()) {
    return (
      <div className="flex items-center gap-3">
        <Badge variant="warning">Solo en escritorio</Badge>
      </div>
    );
  }

  const getLevelClass = (level) => {
    if (level === 'warn') return 'text-amber-700';
    if (level === 'error') return 'text-red-700';
    return 'text-neutral-700';
  };
  const getLevelIcon = (level) => {
    if (level === 'warn') return 'mdi:alert-outline';
    if (level === 'error') return 'mdi:alert-circle-outline';
    return 'mdi:information-outline';
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className={connected ? 'text-green-600' : 'text-amber-600'}>
          {connected ? 'Conectado al proceso principal' : 'Conectando...'}
        </span>
        <span className="text-neutral-400">{logs.length} entradas</span>
      </div>
      <div className="max-h-64 overflow-y-auto bg-neutral-50 rounded p-2 font-mono text-xs">
        {logs.length === 0 ? (
          <div className="text-neutral-400 text-center py-4">Sin logs aun. Imprime algo o espera un momento.</div>
        ) : (
          logs.slice().reverse().map((entry, i) => (
            <div
              key={entry.t + '-' + i}
              className={'py-0.5 px-1 ' + getLevelClass(entry.level)}
            >
              <span className="text-neutral-300 mr-1">
                {new Date(entry.t).toLocaleTimeString()}
              </span>
              <Icon icon={getLevelIcon(entry.level)} className="inline-block w-3 h-3 mr-1" />
              {entry.message}
              {entry.args.length > 0 && (
                <span className="ml-2 text-neutral-400">
                  {entry.args.join(' ')}
                </span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}